(function initCartReserveTimer() {
  const DURATION_SECONDS = 5 * 60; // 5 minutes
  const STORAGE_KEY = 'nuveria_cart_reserved_until';
  let timerInterval = null;

  function formatTime(seconds) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  }

  function resetTimer() {
    const endTime = Date.now() + DURATION_SECONDS * 1000;
    sessionStorage.setItem(STORAGE_KEY, endTime.toString());
    tick();
  }

  window.resetCartReserveTimer = resetTimer;

  function tick() {
    const timerElements = document.querySelectorAll('[data-cart-timer]');
    const cartDrawer = document.querySelector('cart-drawer');
    const isEmpty = cartDrawer ? cartDrawer.classList.contains('is-empty') : false;

    if (timerElements.length === 0 || isEmpty) {
      return;
    }

    let endTime = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
    const now = Date.now();

    if (!endTime || isNaN(endTime)) {
      endTime = now + DURATION_SECONDS * 1000;
      sessionStorage.setItem(STORAGE_KEY, endTime.toString());
    }

    const remainingSeconds = Math.max(0, Math.ceil((endTime - now) / 1000));

    timerElements.forEach((el) => {
      el.textContent = formatTime(remainingSeconds);
    });

    if (remainingSeconds <= 0) {
      if (timerInterval) {
        clearInterval(timerInterval);
        timerInterval = null;
      }
      sessionStorage.removeItem(STORAGE_KEY);
      timerElements.forEach((el) => {
        el.textContent = '0:00';
      });

      // Clear cart
      const clearUrl = (window.routes && window.routes.cart_clear_url) ? window.routes.cart_clear_url : '/cart/clear.js';
      fetch(clearUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      })
      .finally(() => {
        window.location.reload();
      });
    }
  }

  if (!timerInterval) {
    timerInterval = setInterval(tick, 1000);
  }

  tick();

  document.addEventListener('DOMContentLoaded', tick);
  window.addEventListener('load', tick);

  // Hook into Dawn pubsub if available
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      resetTimer();
    });
  }

  // Intercept fetch requests to /cart/add, /cart/change, /cart/update
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
    const isCartMutation = /\/cart\/(add|change|update)/i.test(url);
    
    const fetchPromise = originalFetch.apply(this, args);
    if (isCartMutation) {
      fetchPromise.then((response) => {
        if (response.ok) {
          resetTimer();
        }
      }).catch(() => {});
    }
    return fetchPromise;
  };

  // Listen to standard custom cart events
  ['cart:update', 'cart:updated', 'cart:change', 'cart:refresh', 'cart:build'].forEach((eventName) => {
    document.addEventListener(eventName, resetTimer);
  });
})();

